import Dropdown from 'components/common/Dropdown/Dropdown';
import Link from 'components/common/Link/Link';

/**
 * This page provides an example of Scalyr's dropdown menu component.
 * Some menus in the product may not use the dropdown component, but all menus
 * should use the same styling.
 */

function DropdownExamplePage(): JSX.Element {
  const menuSections1 = [
    [
      {
        as: Link,
        text: 'Item 1',
        href: '#',
      },
      {
        as: Link,
        text: 'Item 2',
        href: '#',
      },
      {
        as: Link,
        text: 'Item 3',
        href: '#',
      },
      {
        as: Link,
        text: 'Item 4',
        href: '#',
      },
      {
        as: Link,
        text: 'Item 5',
        href: '#',
      },
    ],
  ];

  const menuSections2 = [
    [
      {
        as: 'div',
        text: 'Header 1',
        className: 'dropdown-header',
      },
      {
        as: Link,
        text: 'Item A',
        href: '#',
      },
      {
        as: Link,
        text: 'Item B',
        href: '#',
      },
      {
        as: Link,
        text: 'Item C',
        href: '#',
      },
    ],
  ];

  return (
    <section id="dropdown" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Dropdown</h1>

      <div className="d-flex">
        <div className="ExamplesPage__Dropdown mr-3">
          <Dropdown sections={menuSections1} size="med">
            {' '}
            Simple Menu
          </Dropdown>
        </div>
        <div className="ExamplesPage__Dropdown">
          <Dropdown sections={menuSections2} size="med">
            {' '}
            Complex Menu
          </Dropdown>
        </div>
      </div>
    </section>
  );
}
export default DropdownExamplePage;
